import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import gasanzeImg from '../assets/images/projects/gasanze/Birembo (13 of 15).jpg';
import kanombeImg from '../assets/images/projects/kanombe/Kanombe12.jpg'
import biremboImg from '../assets/images/projects/birembo/Birembo12.jpg';
import Sectionbreak from './Sectionbreak';

const projects = [
  {
    title: 'Gasanze Residential Homes',
    date: 'May 2024',
    location: 'Gasanze, Kigali',
    image: gasanzeImg,
    highlights: [
      'Modern design with sustainable materials',
      'Includes 5 residential units',
      'Integrated rainwater harvesting system',
      'Solar-powered lighting and heating',
    ],
  },
  {
    title: 'Kanombe Eco Apartments',
    date: 'February 2023',
    location: 'Kanombe, Kigali',
    image: kanombeImg,
    highlights: [
      'High-efficiency ventilation systems',
      'Community green spaces',
      'Underground parking and security systems',
      'Accessibility-friendly design',
    ],
  },
  {
    title: 'Birembo Commercial Block',
    date: 'August 2022',
    location: 'Birembo, Kigali',
    image: biremboImg,
    highlights: [
      'Mixed-use retail and office spaces',
      'Energy-efficient glass façade',
      'Smart surveillance and access control',
      'Ample parking and public access',
    ],
  },
];

function Projects() {
  return (
    <section id="projects" className="py-20 px-6 bg-gray-50">

        <Sectionbreak
        title='Featured'
        highlight='Projects'
        description='Explore some of our completed and ongoing developments that blend design, innovation, and impact.'
        />

      <div className="max-w-7xl mx-auto space-y-16">
        {projects.map((project, index) => (
          <div
            key={index}
            className={`flex flex-col md:flex-row ${
              index % 2 !== 0 ? 'md:flex-row-reverse' : ''
            } bg-white shadow-md rounded-2xl overflow-hidden`}
          >
            {/* Image */}
            <div className="md:w-1/2 h-64 md:h-auto">
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Content */}
            <div className="md:w-1/2 p-8 flex flex-col justify-center">
              <h3 className="text-2xl font-bold text-teal-700 mb-2">{project.title}</h3>
              <p className="text-sm text-gray-500 mb-4">
                {project.location} — <span>{project.date}</span>
              </p>

              <ul className="space-y-3 mb-6">
                {project.highlights.map((item, idx) => (
                  <li key={idx} className="flex items-start text-gray-700">
                    <FaCheckCircle className="text-teal-600 mt-1 mr-2" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              <button className="mt-auto inline-block bg-teal-600 text-white font-semibold px-5 py-2 rounded hover:bg-teal-700 transition">
                View Details
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Projects;
